import ChatDetailInfoPeople from '@/screens/ChatDetailInfoPeople';

export default function PrivateChatChatIdInfoPeopleRoute() {
  return <ChatDetailInfoPeople />;
}
